import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=afd73af4"
import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd73af4')) {
      api.createRecord('afd73af4', component.options)
    } else {
      api.reload('afd73af4', component.options)
    }
    module.hot.accept("./Skeleton.vue?vue&type=template&id=afd73af4", function () {
      api.rerender('afd73af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeletonPlaceholder/Skeleton.vue"
export default component.exports